<template>
  <div class="container-list">
    <!-- <ul class="tab-wrap" style="border:none" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查任务管理
      </div>
    </div>
    <div class="header_right ">
      <div
      class="ml20 "
      
      @click="searchDate"
    >
    <!-- v-hasPermi="['safe:safeplaceList:query']" -->
      <el-button size="small" icon="el-icon-search" type="primary" >查询</el-button>
    </div>
    <div class="ml20">
      <!-- <div class="btn" @click="$router.push('/wenlv/inspectionTaskCreat')"> -->
      <router-link
        :to="{
          path: '/wenlv/inspectionTaskCreat',
          query: { cpNum: cpNum },
        }"
      >
        <!-- 编辑 -->
        <el-button size="small" type="primary" v-hasPermi="['relic:relicInspectionItem:add']" >创建任务</el-button>
      </router-link>
      <!-- <el-button type="primary" size="small">创建任务</el-button> -->
      <!-- <i class="icon-tr-newly-added"></i> -->
      <!-- </div> -->
    </div>
    </div>
    

    <div class="flex containerPage"  >
      <!-- <div style="width: 20%" v-show="!($store.state.user.userInfo.natureId == 2)">
      <unitList
        @select="getUnit"
        @getFirst="getOne"
        style="margin-top: 20px"
      ></unitList>
      </div> -->

      <el-table :data="list" class="mt10">
        <el-table-column prop="itemName" label="任务名称" align="center">
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="创建时间">
        </el-table-column>
        <el-table-column
          prop="currentProgress"
          align="center"
          label="巡查点位数量及进度"
        >
        </el-table-column>
        <el-table-column prop="inspector" align="center" label="巡查人员">
        </el-table-column>
        <el-table-column prop="timeFrame" align="center" label="时间范围">
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">待下发</span>
            <span v-else-if="scope.row.status == 2">未开始</span>
            <span v-else-if="scope.row.status == 3">巡查中</span>
            <span v-else-if="scope.row.status == 4">已完成</span>
            <span v-else-if="scope.row.status == 5">未完成</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <div style="display:flex;justify-content:center">
               <div v-if="scope.row.status == 1">
              <el-popconfirm
                title="确定要下发任务吗"
                @onConfirm="distributeTasks(scope.row.id)"
                v-hasPermi="['relic:relicInspectionItem:deliverTask']"
              >
                <template #reference>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="下发任务"
                    placement="top"
                  >
                    <el-button
                      type="primary"
                      icon="el-icon-s-promotion"
                      size="mini"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-popconfirm>
              <router-link
                :to="{
                  path: '/wenlv/inspectionTaskCreat',
                  query: { cpNum: cpNum, id: scope.row.id,quick:0  },
                }"
                v-hasPermi="['relic:relicInspectionItem:editInfo']"
              >
                <!-- 编辑 -->
                <el-tooltip
                  class="item"
                  effect="light"
                  content="编辑"
                  placement="top"
                >
                  <el-button
                    type="warning"
                    icon="el-icon-edit-outline"
                    size="mini"
                  ></el-button>
                </el-tooltip>
              </router-link>
              <el-popconfirm
                title="确定要删除吗"
                @onConfirm="taskDelete(scope.row.id)"
              >
                <template #reference>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="删除"
                    placement="top"
                  >
                    <el-button
                      type="danger"
                      icon="el-icon-delete-solid"
                      size="mini"
                      v-hasPermi="['relic:relicInspectionItem:remove']"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-popconfirm>
            </div>
            <div style="" v-else>
              <router-link
                :to="{
                  path: '/wenlv/inspectionTaskDetail',
                  query: { id: scope.row.id },
                }"
              >
                <!-- 编辑 -->
                <el-tooltip
                  class="item"
                  effect="light"
                  content="查看详情"
                  placement="top"
                >
                  <el-button
                    type="success"
                    icon="el-icon-s-unfold"
                    size="mini"
                    v-hasPermi="['relic:relicInspectionItem:getInfo']"
                  ></el-button>
                </el-tooltip>
                <!-- <el-button type="primary" size="mini">查看详情</el-button> -->
              </router-link>
              <el-tooltip
                class="item"
                effect="light"
                content="巡检地图"
                placement="top"
              >
                <el-button
                  type="info"
                  icon="el-icon-map-location"
                  size="mini"
                  @click="showDilog(scope.row.id)"
                  v-hasPermi="['relic:relicInspectionItem:inspectorList']"
                ></el-button>
              </el-tooltip>
              <!-- <el-button size="mini">巡检地图</el-button> -->
            </div>
            <router-link
                :to="{
                  path: '/wenlv/inspectionTaskCreat',
                  query: { cpNum: cpNum, id: scope.row.id,quick:1 },
                }"
                v-hasPermi="['relic:relicInspectionItem:quickDelivery']"
              >
               <!-- v-hasPermi="['relic:relicInspectionItem:quickDelivery']" -->
                <!-- 编辑 -->
                <el-tooltip
                  class="item"
                  effect="light"
                  content="复制任务"
                  placement="top"
                >
                  <el-button
                    icon="el-icon-position"
                    size="mini"
                  ></el-button>
                </el-tooltip>
              </router-link>
            </div>
           
          </template>
        </el-table-column>
      </el-table>

      <!-- <div style="width:90%;height:500px" id="container">
                 <el-amap :vid="'amap-vue'" :zoom="zoom" :center="center" :events="events">
                    <el-amap-marker  v-for="item in marker" :position="item.position" :events="item.events" :icon="item.icon" :visible="item.visible" :draggable="item.draggable" :label="item.label" ></el-amap-marker>
                </el-amap>
            </div> -->
    </div>
    <div style="width:100%;display:flex;justify-content: flex-end;">
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next"
        :current-page.sync="pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size.sync="pageSize"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="地图"
      :visible.sync="showDia"
      :close-on-click-modal="false"
      width="90%"
    >
      <!-- <el-button>查看全部巡查轨迹</el-button> -->
      <el-select
        v-model="personPoint"
        placeholder="查看全部巡查轨迹"
        @change="changeValue"
      >
        <el-option
          v-for="item in personList"
          :key="item.userId"
          :label="item.nickName"
          :value="item.userId"
        >
        </el-option>
      </el-select>
      <div id="container" style="width:100%;height:500px"></div>
    </el-dialog>
     <el-dialog
      title="查询"
      :visible.sync="showDia1"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px">
       
        <el-form-item label="任务名称" prop="desc">
          <el-input v-model="form.itemName"></el-input>
        </el-form-item>
         <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option
              v-for="item in list1"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit('form')" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
    <!-- <tab9></tab9> -->
  </div>
</template>

<script>
import { getSafeList } from "../../api/safety";
import unitList from "@/components/unitList1";
import tab9 from "@/views/facility/tab9";
import axios from "axios";

export default {
  data() {
    let self = this;
    return {
      cpNum: this.$store.state.user.company.cCompanyNum || "",
      companyNum: this.$store.state.user.company.cCompanyNum || "",
      list: [],
      zoom: 13,
      marker: [],
      center: [120.36173, 36.082949],
      events: {
        click: (e) => {
          console.log(e, 11111111111);
          this.marker.position = [e.lnglat.lng, e.lnglat.lat];
        },
      },
      total: 0,
      pageNum: 1,
      pageSize: 10,
      showDia: false,
      showDia1: false,
      personPoint: "",
      totleMap: null,
      markerList: [],
      personList: [],
      personMarkList: [],
      itemId: null,
      polyline2: null,
      line: [],
      form:{
        itemName:'',
        status:''
      },
      list1:[
        {name:'待下发',value:1},
        {name:'未开始',value:2},
        {name:'巡查中',value:3},
        {name:'已完成',value:4},
        {name:'未完成',value:5},
        ]
    };
  },
  created() {
    // if (this.cpNum) {
    console.log('creaty');

       this.getList();
    // }
   
    
  },
  mounted() {
  },
  components: {
    unitList,
  },
  watch: {},
  methods: {
     searchDate() {
      this.form={
        itemName:'',
        status:''
      },
      this.showDia1 = true;
    },
    cancle() {
      this.form={
        itemName:'',
        status:''
      },
      console.log('cancel');
      this.getList();
      this.showDia1 = false;
    },
    searchSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.form);
          // var obj = { ...this.params1, ...this.form };
          // this.params1 = obj;
          // this.params1.page = 1;
          console.log('searchSubmit');
          this.getList();
          this.showDia = false;

          // alert('submit!');
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeValue(val) {
      // console.log(val, this.personList,111);
      this.$get(
        "/relic/relicInspectionGeo/list?userId=" +
          val +
          "&itemId=" +
          this.itemId
      ).then((res) => {
        // console.log(res,2222);
        this.personMarkList = res.data;
        this.makeLine();
      });
    },
    showDilog(itemId) {
      this.itemId = itemId;
      this.personList = [];
      this.personPoint = null;
      this.$get(
        "/relic/relicInspectionItem/inspectorList?itemId=" + itemId
      ).then((res) => {
        // log(res, 4444);
        this.personList = res.data.checkUserBasicList;
        this.markerList = res.data.relicInspectionPointInfoList;
        this.showDia = true;
        this.$nextTick(() => {
          this.initMap();
        });
      });
    },
    initMap() {
      let gpsLat = this.markerList[0].gpsLat;
      let gpsLon = this.markerList[0].gpsLon;
      console.log(gpsLat,gpsLon,6666);
      this.totleMap = new AMap.Map("container", {
        center: [gpsLon, gpsLat],
        zoom: 10,
        resizeEnable: true,
      });
      this.makeMarker();
    },
    makeMarker() {
      // console.log(this.markerList, 33333333);
      this.markerList.forEach((item, index) => {
        // console.log(item);
        //添加点标记
        let marker = new AMap.Marker({
          position: [item.gpsLon, item.gpsLat],
          offset: new AMap.Pixel(-1, -3),
          icon:
            item.status == 0
              ? require("../../assets/img/redgps.png")
              : require("../../assets/img/greengps.png"),
          label: {
            content: `巡查点：${item.pointName}${
              item.nickName == null ? "" : "<br />巡查人:" + item.nickName
            }<br />${
              item.inspectTime == null ? "" : "巡查时间:" + item.inspectTime
            }`,
            offset: new AMap.Pixel(30, 0),
          },
        });
        this.totleMap.add(marker);
      });
    },
    makeLine() {
      this.totleMap.remove(this.line);
      this.line = [];
      // this.totleMap.remove(this.polyline2)
      // this.polyline2.setMap(null)

      // console.log(this.personMarkList,'this.personMarkList')
      let path2;
      path2 = this.personMarkList.map((item) => {
        return [item.gpsLon, item.gpsLat];
      });
      // console.log(path2);

      let polyline2 = new AMap.Polyline({
        path: path2,
        isOutline: true,
        outlineColor: "#ffeeff",
        borderWeight: 3,
        strokeColor: "#3366FF",
        strokeOpacity: 1,
        strokeWeight: 6,
        // 折线样式还支持 'dashed'
        strokeStyle: "dashed",
        // strokeStyle是dashed时有效
        strokeDasharray: [15, 5],
        lineJoin: "round",
        lineCap: "round",
        zIndex: 50,
      });
      polyline2.setMap(this.totleMap);
      // this.totleMap.add([this.polyline2]);
      this.totleMap.setFitView();
      this.line.push(polyline2);
    },
    handleSizeChange(val) {
      this.pageSize = val; //更新每页的条数
          console.log('handleSizeChange');

      this.getList(); //重新获取列表数据
    },
    handleCurrentChange(val) {
          console.log('handleCurrentChange');

      this.pageNum = val; //重新获取列表数据
      this.getList();
    },
    taskDelete(id) {
      this.$remove("/relic/relicInspectionItem/" + id).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 1000,
          });
          this.getList();
        }
      });
          console.log('taskDelete');

      
    },
    distributeTasks(id) {
      this.$get("/relic/relicInspectionItem/deliverTask/" + id).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "下发成功",
            type: "success",
            duration: 1000,
          });
          console.log('distributeTasks');

          this.getList();
        }
      });
    },
    creatMap() {},
    getList() {
      this.$get(
        "/relic/relicInspectionItem/list?companyNum=" +
          this.cpNum +
          "&pageNum=" +
          this.pageNum +
          "&pageSize=" +
          this.pageSize+
          "&status=" +
          this.form.status+
          "&itemName=" +
          this.form.itemName
      ).then((res) => {
        console.log(res, 1);
        this.list = res.rows;
        this.total = res.total;
      });
    },
    getOne(v) {
      console.log(v);
      this.cpNum = v;
          console.log('getOne');

      this.getList();
    },
    getUnit(v) {
      console.log(v);
      this.cpNum = v;
          console.log('getUnit');

      this.getList();
    },
  },
};
</script>

<style scoped>
.btn {
  margin-left: 10px;
}
.header_right {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
